module.exports = __webpack_public_path__ + "static/media/slide 1.210f2dc4.jpg";